import { Injectable, inject } from '@angular/core';
import * as ExcelJS from 'exceljs';
import FileSaver from 'file-saver';
import { HideIDColumnsPipe } from 'src/app/pipes/hide-idcolumns.pipe';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root',
})
export class ExcelService {
  private hideIDColumnsPipe = inject(HideIDColumnsPipe);

  public exportAsExcelFile(json: any[], excelFileName: string, hideIDColumns = true, includeColums?: string[]): void {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet('data');

    // Filter Spalten, wenn hideIDColumns true ist
    const filteredKeys = Object.keys(json[0]).filter(key => !hideIDColumns || !this.hideIDColumnsPipe.transform(key));

    filteredKeys.unshift(...(includeColums || []).filter(col => !filteredKeys.includes(col)));

    // Header row in uppercase
    const headerRow = sheet.addRow(filteredKeys.map(k => k.toUpperCase()));

    // Style header row
    headerRow.eachCell(cell => {
      cell.font = { bold: true, color: { argb: 'FFF1F6F8' } };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF2582C5' },
      };
    });

    // Add data rows (nur sichtbare Spalten)
    json.forEach(item => {
      const rowData = filteredKeys.map(key => item[key]);
      sheet.addRow(rowData);
    });

    // Auto-size columns
    sheet.columns.forEach((column, i) => {
      const columnValues = [
        headerRow.getCell(i + 1).value?.toString() || '',
        ...column.values.slice(1).map(v => (v !== null && v !== undefined ? v.toString() : '')),
      ];

      let maxLength = 10;
      for (const val of columnValues) {
        if (val && val.length > maxLength) maxLength = val.length;
      }

      column.width = maxLength + 2;
    });

    // AutoFilter auf Header
    sheet.autoFilter = {
      from: { row: 1, column: 1 },
      to: { row: 1, column: filteredKeys.length },
    };

    // Save Excel
    workbook.xlsx.writeBuffer().then(buffer => {
      const data = new Blob([buffer], { type: EXCEL_TYPE });
      FileSaver.saveAs(data, excelFileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
    });
  }
}
